<script>
import Loader from "../../../small_components/Loader.vue";
import GrayText from "../../../small_components/GrayText.vue";
import {axiosSiteStatus} from "../../../../helpers/axios_requests";
import DefaultBox from "../../../slots/DefaultBox.vue";
import SmallTitle from "../../../small_components/SmallTitle.vue";
import RouterLinkTo from "../../../small_components/RouterLinkTo.vue";
import routes_mixin from "../../../../mixins/routes_mixin";
import DefaultSelect from "../../../small_components/DefaultSelect.vue";
import Switcher from "../../../small_components/Switcher.vue";
import CloseIcon from "../../../icons/CloseIcon.vue";
import DefaultButton from "../../../small_components/DefaultButton.vue";
import DefaultInput from "../../../small_components/DefaultInput.vue";
import TablesSlot from "../../../small_components/tables/TablesSlot.vue";
import LogoutIcon from "../../../icons/LogoutIcon.vue";
import EditIcon from "../../../icons/EditIcon.vue";
import DefaultTitle from "../../../small_components/DefaultTitle.vue";

export default {
  mixins: [routes_mixin],
  name: "UsersVacationsStatistic",
  components: {
    DefaultTitle,
    EditIcon, LogoutIcon, TablesSlot, DefaultInput, DefaultButton, CloseIcon, Switcher,
    DefaultSelect,
    RouterLinkTo,
    SmallTitle,
    DefaultBox,
    Loader,
    GrayText
  },
  computed: {
  },
  props: {
    start: {
      type: String,
      required: true
    },
    end: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      loading: false,
      loaded: false,
      statistics: [],
      pagination: [],
    }
  },
  mounted() {
    this.fetchStatistic()
  },
  methods: {
    fetchStatistic() {
      this.loading = true
      axiosSiteStatus.vacations({start_date: this.start, end_date: this.end}).then(({data}) => {
        this.statistics = data.statistics || []
      }).finally(() => {
        this.loading = false
        this.loaded = true
      })
    },
  }
}
</script>

<template>
  <div class="user-upcoming-vacation">
    <div v-if="loaded && !statistics.length">
      <gray-text>{{$t('tables.no_data_can_be_loaded')}}</gray-text>
    </div>
    <div v-else>
      <tables-slot
          :empty_spacer="loading"
          :pagination="pagination">
        <template v-slot:table_head>
          <td class="w-0 text-nowrap">#</td>
          <td class="w-0 text-nowrap">{{ $t('inputs.name') }}</td>
          <td class="w-0 text-nowrap">{{ $t('statistic.days_on_vacations') }}</td>
        </template>
        <template v-slot:table_body>
          <tr v-for="item in statistics">
            <td class="w-0 text-nowrap">
              {{ item.user_id }}
            </td>
            <td class="w-0 text-nowrap">
              <router-link-to
                  class="d-inline-block px-10 py-10"
                  :route_params="{id: item.user_id}"
                  :route_name="route_names.user">
                {{ item.user_name + ' ' + item.user_surname}}
              </router-link-to>
            </td>
            <td
                class="w-0 text-nowrap">
              {{ item.days_on_vacations }}
            </td>
          </tr>
        </template>
      </tables-slot>
    </div>
    <loader v-if="loading"/>
  </div>
</template>

<style>

</style>